// extracted by mini-css-extract-plugin
export default {"stoppingInfo":"wujRI"};